import {customElement, property} from 'lit/decorators.js';
import {filter, merge} from 'rxjs';

import {Activity} from './activity';
import {ActivityQueueItem} from './activity-queue-item';
import {performActivityFromQueue, ri} from './runner-idle';
import {ActivityName} from './types/runner-idle';
import {fancy, formatTime} from './utils';

@customElement('ri-batch')
export class Batch extends Activity {
  // #region Properties (12)

  protected override baseTags = new Set(['batch']);

  @property() public override displayName = 'Batch';
  //HACK
  @property() public override name = 'batch' as ActivityName;

  override toJSON() {
    return {
      ...super.toJSON(),
      activityQueue: this.activityQueue.map((queueItem) => ({
        name: queueItem.activity.name,
        repeat: queueItem.repeat,
        activeIndex: queueItem.activeIndex,
        option: queueItem.option,
      })),
      activityQueueIndex: this.activityQueueIndex,
      unlocked: true,
      secret: false,
      new: false,
    };
  }

  /**
   * The Activity that this Batch just did? Will do next?
   * I made this stuff obtuse with bad names and didn't fix it at the time,
   * like a putz.
   * !TODO
   * !HACK
   */
  public activeActivity: Activity | null = null;
  public activityQueue: ActivityQueueItem[] = [];
  public activityQueueIndex = 0;
  public lastCompletedActivity: Activity | null = null;
  public override perform = (step: number, _optionIndex: number) => {
    if (step == this.activityQueue.reduce((acc, q) => acc + q.totalDuration, 0))
      this.log('End of Queue');
    // BROKEN
    return performActivityFromQueue(1000, this, () => {});
  };

  public get _batchTooltip() {
    return `${this.description}
      <br><br>${this.activityQueue
        .map(
          (q) =>
            `${fancy(q.activity.name, q.activity.displayName)}${
              q.activity.options.length
                ? ` ${q.activity.options[q.optionIndex]}`
                : ''
            } x ${q.repeat}`
        )
        .join('<br>')}
      ${this.tooltipContent() ? '<br><br>' + this.tooltipContent() : ''}
      <br><br>Uses: ${this.uses}
      <br>Time Spent: ${formatTime(this.timeSpent)}
      <br>Tags: ${[...this.baseTags]}`;
  }

  /**
   * @Batch The sum of the lengths of the Activities in the Batch's Activity Queue.
   *  */
  public override get duration() {
    return this.activityQueue.reduce((acc, q) => acc + q.totalDuration, 0);
  }

  public override set duration(_val) {
    throw new Error("Can't set the duration of a Batch manually!");
  }

  public override get tags() {
    return this.activeActivity?.tags ?? new Set(['batch']);
  }

  // #endregion Properties (12)

  // #region Public Methods (5)

  public override _updateTooltip() {
    this.tooltip?.setContent(this._batchTooltip);
  }

  public delete() {
    delete ri.batches[this.name];
    this.replaceQueueItemsWith(this.activityQueue);
  }

  public initWithQueue(activityQueue: ActivityQueueItem[] = []) {
    this.activityQueue = activityQueue.map((queueItem) => {
      const newActivityQueueItem = document.createElement(
        'ri-activity-queue-item'
      ) as ActivityQueueItem;
      newActivityQueueItem.activity = queueItem.activity;
      newActivityQueueItem.option = queueItem.option;
      newActivityQueueItem.repeat = queueItem.repeat;
      return newActivityQueueItem;
    });
  }

  public log(msg: string) {
    ri.log(`${this.displayName}: ${msg}`, ['batch']);
  }

  public override setup() {
    super.setup();
    // Delete on alt-click
    this.leftClick$
      .pipe(filter((e) => e.altKey))
      .subscribe(this.delete.bind(this));
    // Edit on right-click
    merge(this.rightClick$, this.contextMenu$).subscribe((event) => {
      event?.preventDefault();
      this.edit();
    });
  }

  // #endregion Public Methods (5)

  // #region Private Methods (1)

  private edit() {
    // Don't edit if already editing a batch
    if (!ri.editingBatch) {
      ri.editingBatch = this;
      ri.loadouts[ri.lastLoadoutIndex] = ri.activityQueue;
      ri.beforeBatchLoadoutIndex = ri.lastLoadoutIndex;
      ri.lastLoadoutIndex = -1;
      ri.activityQueue = this.activityQueue;
      const batchNameEl = ri.shadowRoot?.getElementById(
        'batch-name-input'
      ) as HTMLInputElement;
      batchNameEl.value = this.displayName;
      ri.lastGameSpeed = ri.gameSpeed;
      ri.togglePause(true);
      ri.requestUpdate();
    }
  }

  // #endregion Private Methods (1)
}
